import { DashboardModule } from '@domain-group/suit-theme'

import { useFilters } from '@domain-group/react-hooks'

import DashboardModuleFilters from '@components/DashboardModuleFilters'

import useFavouriteOrders from '@hooks/useFavouriteOrders'
import FavouriteOrderListItem from './FavouriteOrderListItem'

const buildPageFilterFields = () => {
  const style = {
    marginBottom: 16,
  }

  return [
    {
      component: 'DynamicInput',
      componentProps: {
        inputComponent: 'input',
        style,
      },
      key: 'string',
      label: 'Favourite Order Title or ID',
    },
  ]
}

interface FavouriteOrdersProps {
  providerPriceListId: number,
}

const FavouriteOrders = (props: FavouriteOrdersProps) => {
  const { providerPriceListId } = props

  const filterPayload = useFilters()
  const {
    pageFilters,
  } = filterPayload

  const favouriteOrderPayload = useFavouriteOrders({
    filters: {
      ...pageFilters,
      provider_price_list_id: providerPriceListId,
    },
    performHttpRequests: !!providerPriceListId,
    requestOptions: {
      include_favourite_order_agency: true,
      include_favourite_order_price_list_ids: true,
    },
  })

  const {
    callbacks: {
      loadMore,
    },
    canLoadMore,
    filteredFavouriteOrders,
    filteredFavouriteOrdersCount,
    hasFilteredFavouriteOrders,
    loading,
  } = favouriteOrderPayload

  return (
    <DashboardModule
      contentBoxProps={{ flexDirection: 'column' }}
      headerRight={<DashboardModule.FilterHeader {...filterPayload} />}
      loading={loading}
      title="Favourite Orders"
    >
      <DashboardModuleFilters
        filterFields={buildPageFilterFields()}
        {...filterPayload}
      />

      {!loading && hasFilteredFavouriteOrders && (
        <DashboardModule.ScrollableSection>
          {filteredFavouriteOrders.map(favouriteOrder => (
            <FavouriteOrderListItem
              key={favouriteOrder.id}
              favouriteOrder={favouriteOrder}
            />
          ))}
        </DashboardModule.ScrollableSection>
      )}

      {!loading && !hasFilteredFavouriteOrders && (
        <DashboardModule.BlankState>
          <DashboardModule.BlankState.Title>
            No Favourite Orders Present
          </DashboardModule.BlankState.Title>

          <DashboardModule.BlankState.Paragraph>
            Favourite Orders will appear here when favourite order items are assigned to this Price List
          </DashboardModule.BlankState.Paragraph>
        </DashboardModule.BlankState>
      )}

      <DashboardModule.LoadMoreFooter
        boxProps={{ borderTop: loading ? 'none' : '1px solid' }}
        callbacks={{ loadMore }}
        canLoadMore={canLoadMore}
        entityCount={filteredFavouriteOrdersCount}
        loading={loading}
      />
    </DashboardModule>
  )
}

export default FavouriteOrders
